import React from "react";
import dayjs from "dayjs";

// Shown once after creating an admin or resetting their sign-in. The admin
// hands this to the user, who must replace it and register an authenticator
// at their first sign-in.
const TemporaryPassword = ({ username, temporaryPassword, expiresAt }) => (
  <div>
    <div className="mb-2">
      Username: <strong>{username}</strong>
    </div>
    <div className="mb-1">Temporary password</div>
    <div className="d-flex align-items-center gap-2 mb-2">
      <code style={{ fontSize: 18, letterSpacing: 1 }}>
        {temporaryPassword}
      </code>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={() => navigator.clipboard?.writeText(temporaryPassword)}
      >
        Copy
      </button>
    </div>
    <div className="text-muted small">
      Expires {dayjs(expiresAt).format("DD MMM YYYY, h:mm A")}. It will not be
      shown again.
    </div>
  </div>
);

export default TemporaryPassword;
